import type { Policy } from "./Policy";

export class InvoiceTransaction {
    id: string;
    invoiceId: string;
    transactionType: Policy.TransactionType;
    description?: string;
    premium: number;
    policyTransactionEffectiveDate: Date;
    chargeCategory?: string;
    chargeCode?: string;
}
